export default "__VITE_ASSET__tK2dxbei__"